import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import PredictionGraph from "./PredictionGraph";
import { MLModelTypeSelectorProps } from "../types";

function MLModelTypeSelector({
  selectedModel,
  setSelectedModel,
  showPredictionGraph,
  setShowPredictionGraph,
}: MLModelTypeSelectorProps) {
  const [openModal, setOpenModal] = useState(false);

  const modelOptions = [
    { label: "Select ML Model", value: "Select ML Model" },
    { label: "Neural Network", value: "NN" },
    { label: "Random Forest", value: "RF" },
    { label: "KNN", value: "KNN" }, // working
    { label: "Gradient Boosting", value: "GB" }, //Working
    { label: "Linear Regression", value: "LR" }, //Working
  ];

  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    setSelectedModel(value);
    if (value !== "Select ML Model") {
      setOpenModal(true);
    }
  };

  const handleClose = () => {
    setOpenModal(false);
    setSelectedModel("Select ML Model");
    setShowPredictionGraph(false);
  };

  const handleConfirm = () => {
    setShowPredictionGraph(true);
    setOpenModal(false);
  };

  return (
    <>
      <Select
        value={selectedModel}
        onChange={handleChange}
        size="small"
        sx={{ bgcolor: "white", width: 200 }}
      >
        {modelOptions.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>

      <Dialog
        open={openModal}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2, p: 1 } }}
      >
        <DialogTitle>Confirm Selection</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You selected <strong>{selectedModel}</strong>. Would you like to
            proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="error">
            Cancel
          </Button>
          <Button onClick={handleConfirm} variant="contained" color="primary">
            Generate
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default MLModelTypeSelector;
